'use client';
import React from 'react';

import { PromoBannerType } from '@nutralab/api';

import { classNames } from '@m1work/shared-utils';

import styles from './OrderSuccessBanner.module.scss';

import { BannerHtml } from '@/app/_components/BannerHtml';
import { useSiteConfig } from '@/app/_providers/SiteConfigProvider';

export interface OrderSuccessBannerProps {
    className?: string;
}

/** The CMS banner on the "order placed" screens (quick order, cart); renders nothing when the backend has none. */
export function OrderSuccessBanner({ className }: OrderSuccessBannerProps): React.ReactElement | null {
    const { promo_banners } = useSiteConfig();

    const banner = promo_banners.find((b) => b.type === PromoBannerType.ORDER_SUCCESS);

    if (!banner) {
        return null;
    }

    return (
        <div className={classNames(styles.cell, className)}>
            <BannerHtml html={banner.html} />
        </div>
    );
}
